// extracted by mini-css-extract-plugin
export default {"container":"np-z","ratingLayout":"op-z","ratingLabel":"pp-z","nonInteractiveRatingLabel":"qp-z"};